/**
 * Workspace utility functions
 */

/**
 * Get current workspace ID from localStorage or auth context
 * Defaults to 'default' for backward compatibility
 */
export function getCurrentWorkspaceId(): string {
  // Try to get from localStorage (set during login)
  const workspaceId = localStorage.getItem('workspace_id');
  if (workspaceId) {
    return workspaceId;
  }

  // Try to get from user object
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user.workspace_id || user.workspaceId) {
        return user.workspace_id || user.workspaceId;
      }
    } catch (e) {
      console.error('Failed to parse user from localStorage', e);
    }
  }

  // Default fallback
  return 'default';
}

/**
 * Set current workspace ID in localStorage
 */
export function setCurrentWorkspaceId(workspaceId: string): void {
  localStorage.setItem('workspace_id', workspaceId);
}

/**
 * Clear workspace ID from localStorage
 */
export function clearWorkspaceId(): void {
  localStorage.removeItem('workspace_id');
}
